import { MOSCOW_AND_REGION_ID, MOSCOW_REGION_ID } from 'shared/constants/regions';
import { TLocation } from 'shared/types/location';
import { getRegionId } from './getRegionId';

export const getRegionIdForDirections = (location: TLocation): number => {
  let regionId = getRegionId(location);

  if (regionId === MOSCOW_AND_REGION_ID) {
    regionId = MOSCOW_REGION_ID;
  }

  return regionId;
};
